import React from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import pictureDE from "../../../../../images/LVText/20241908_Streuungsfaktoren_Ableitung_Pfahlprobebelastungen_DE.png";
import pictureEN from "../../../../../images/LVText/20241908_Streuungsfaktoren_Ableitung_Pfahlprobebelastungen_DE.png";
import pictureES from "../../../../../images/LVText/20241908_Streuungsfaktoren_Ableitung_Pfahlprobebelastungen_DE.png";

function DispersionCoefficientImage({ show, setShow }) {
  const { i18n } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image
            // TODO: EN und ES Bild fehlt
            src={
              i18n.language === "de-DE"
                ? pictureDE
                : i18n.language === "es-ES"
                  ? pictureES
                  : pictureEN
            }
            alt=""
            width={512}
          />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default DispersionCoefficientImage;
